/**
 * Generated runtime TestId mirror for frontend/src/pages/Types.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const TypesTestIds = {
  typesPage: "types-page",
  cardTitleType: (table_tableName: string) => `card-title-type-${table_tableName}`,
  cardTitleTypePrefix: () => "card-title-type-" as TestIdPrefix
} as const;
